import { MarketplaceBankingSubProductTypeEnum } from '@repo/supergraph/marketplace/enums';

export const LOGO_MAX_WIDTH_MOBILE = '224px';
export const LOGO_MAX_WIDTH_DESKTOP = '195px';
export const LOGO_MAX_WIDTH_STICKY_SIDE_BAR = '222px';
export const LOGO_MAX_HEIGHT_MOBILE = '125px';
export const LOGO_IMAGE_SIZE = 152;
export const PRODUCT_NAV_SECTION_MIN_HEIGHT_DESKTOP = 152; // Leave space for 3 product nav items
export const MOBILE_SCROLL_OFFSET = 100;

export const PRODUCT_NAV_ACTION_NAME_MAP = {
  [MarketplaceBankingSubProductTypeEnum.CHECKING]: 'checking',
  [MarketplaceBankingSubProductTypeEnum.SAVINGS]: 'savings',
  [MarketplaceBankingSubProductTypeEnum.CD]: 'CD',
  [MarketplaceBankingSubProductTypeEnum.MONEY_MARKET]: 'MMA',
  [MarketplaceBankingSubProductTypeEnum.PREMIUM_MONEY_MARKET]: 'MMA',
  [MarketplaceBankingSubProductTypeEnum.CASH_MANAGEMENT]: 'cash_management',
  [MarketplaceBankingSubProductTypeEnum.PREPAID]: 'prepaid',
} as const;
